import { render, staticRenderFns } from "./image-choice-response.vue?vue&type=template&id=11272a43&scoped=true&"
import script from "./image-choice-response.vue?vue&type=script&lang=js&"
export * from "./image-choice-response.vue?vue&type=script&lang=js&"
import style0 from "./image-choice-response.vue?vue&type=style&index=0&id=11272a43&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11272a43",
  null
  
)

component.options.__file = "image-choice-response.vue"
export default component.exports